<div class="login-box text-center">
  <div class="mb-3">登录查看更多观看记录</div>
  <a class="dn-btn" href="javascipt:void(0)">立即登录</a>
</div>
